import { MassBatchResultListComponent } from './components/payroll/timesheets/mass-adjustments/mass-batch-result-list/mass-batch-result-list.component';
import { MassBatchErrorListComponent } from './components/payroll/timesheets/mass-adjustments/mass-batch-error-list/mass-batch-error-list.component';
import { GlobalSearchComponent } from './components/global-search/global-search/global-search.component';
import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './components/core/home/home.component';
import { AuthorizationComponent } from './components/lead-details/authorization/authorization.component';
import { MemberViewComponent } from './components/lead-details/member-view/member-view.component';
import { LeadInformationComponent } from './components/lead-details/participant-information/lead-information/lead-information.component';
import { CommPreferenceComponent } from './components/leads/comm-preference/comm-preference.component';
import { ContactDetailsComponent } from './components/leads/contact-details/contact-details.component';
import { NewReferralComponent } from './components/leads/new-referral/new-referral.component';
import { ParticipantInformationComponent } from './components/leads/participant-information/participant-information.component';
import { ReferralLogicComponent } from './components/leads/referral-logic/referral-logic.component';
import { SummaryComponent } from './components/leads/summary/summary.component';
import { ParticipantLeadsListComponent } from './components/participant-leads-list/participant-leads-list.component';
import { ProviderLeadsListComponent } from './components/provider-leads-list/provider-leads-list.component';
import { MessageComponent } from '@ppl/ui';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { EnrollmentListComponent } from './components/enrollment/enrollment-list/enrollment-list.component';
import { EnrollmentListComponentOld } from './components/enrollment/enrollment-list_old/enrollment-list.component';
import { NewEnrollmentComponent } from './components/enrollment/new-enrollment/new-enrollment.component';
import { ParticipantEnrollmentListComponent } from './components/enrollment/participant-enrollment-list/participant-enrollment-list.component';
import { ProviderEnrollmentListComponent } from './components/enrollment/provider-enrollment-list/provider-enrollment-list.component';
import { AdditionalAttributesComponent } from './components/lead-details/additional-attributes/additional-attributes.component';
import { AssociationsComponent } from './components/lead-details/associations/associations.component';
import { ChecklistComponent } from './components/lead-details/check-list/ppl-checklist/checklist.component';
import { CommunicationDetailsComponent } from './components/lead-details/communication-details/communication-details/communication-details.component';
import { DocumentsComponent } from './components/lead-details/documents/documents/documents.component';
import { EmployerComponent } from './components/lead-details/employer/employer/employer.component';
import { LeadDetailSignatureComponent } from './components/lead-details/lead-detail-signature/lead-detail-signature.component';
import { ProspectiveParticipantsComponent } from './components/lead-details/prospective-participants/prospective-participants/prospective-participants.component';
import { LeadDetailSummaryComponent } from './components/lead-details/summary/lead-detail-summary/lead-detail-summary.component';
import { ToDoListComponent } from './components/lead-details/to-do-list/to-do-list/to-do-list.component';
import { FormChecklistComponent } from './components/leads/form-checklist/form-checklist.component';
import { NewContactComponent } from './components/leads/new-contact/new-contact.component';
import { ServiceDetailsComponent } from './components/leads/service-details/service-details.component';
import { UploadDocsComponent } from './components/leads/upload-docs/upload-docs.component';
import { UploadSignaturesComponent } from './components/leads/upload-signatures/upload-signatures.component';
import { ReferralListComponent } from './components/referral/referral-list/referral-list.component';
import { AuthGuard } from './shared/authorization/auth.gaurd';
import { ProcessCodeListComponent } from './components/payroll/process-codes/process-code-list/process-code-list.component';
import { AddProcessCodeComponent } from './components/payroll/process-codes/add-process-code/add-process-code.component';
import { ServiceCodeListComponent } from './components/payroll/service-codes/service-code-list/service-code-list.component';
import { AddServiceCodeComponent } from './components/payroll/service-codes/add-service-code/add-service-code.component';
import { ParticipantProviderRatesListComponent } from './components/payroll/participant-provider-rates/participant-provider-rates-list/participant-provider-rates-list.component';
import { AddParticipantProviderRatesComponent } from './components/payroll/participant-provider-rates/add-participant-provider-rates/add-participant-provider-rates.component';
import { AuthorizationsListComponent } from './components/payroll/authorizations/authorizations-list/authorizations-list.component';
import { SpendingPlansListComponent } from './components/payroll/authorizations/spending-plans-list/spending-plans-list.component';
import { AddAuthorizationComponent } from './components/payroll/authorizations/add-authorization/add-authorization.component';
import { AuthorizationDetailsComponent } from './components/payroll/authorizations/authorization-details/authorization-details.component';
import { FileTriageListComponent } from './components/fileTriage/file-triage-list/file-triage-list.component';
import { AuthorizationMemberViewComponent } from './components/payroll/authorizations/authorization-member-view/authorization-member-view.component';
import { PayableProviderRatesListComponent } from './components/payroll/payable-provider-rates/payable-provider-rates-list/payable-provider-rates-list.component';
import { BillableProviderRatesListComponent } from './components/payroll/billable-provider-rates/billable-provider-rates-list/billable-provider-rates-list.component';
import { AddPayableProviderRatesComponent } from './components/payroll/payable-provider-rates/add-payable-provider-rates/add-payable-provider-rates.component';
import { AddBillableProviderRatesComponent } from './components/payroll/billable-provider-rates/add-billable-provider-rates/add-billable-provider-rates.component';
import { FileUploadNotificationListComponent } from './components/file-upload-notification/file-upload-notification-list/file-upload-notification-list.component';
import { BenefitsComponent } from './components/lead-details/benefits/benefits.component';
import { CaseManagerListComponent } from './components/case-manager/case-manager-list/case-manager-list.component';
import { CaseManagerDetailsComponent } from './components/case-manager/case-manager-details/case-manager-details.component';
import { TimesheetStaffListComponent } from './components/payroll/timesheets/timesheet-staff-list/timesheet-staff-list.component';
import { TimesheetProviderListComponent } from './components/payroll/timesheets/timesheet-provider-list/timesheet-provider-list.component';
import { TimesheetConsumerListComponent } from './components/payroll/timesheets/timesheet-consumer-list/timesheet-consumer-list.component';
import { PayrollProcessingComponent } from './components/payroll/payroll-processing/payroll-processing.component';
import { TimesheetDetailComponent } from './components/payroll/timesheets/timesheet-detail-component/timesheet-detail.component';
import { ViewBatchesComponent } from './components/billing/batches/view-batches/view-batches.component';
import { BatchesListComponent } from './components/billing/batches/batches-list/batches-list.component';
import { ViewClaimsComponent } from './components/billing/claims/view-claims/view-claims.component';
import { ViewFilesComponent } from './components/billing/files/view-files/view-files.component';
import { FilesListComponent } from './components/billing/files/files-list/files-list.component';
import { ClaimsListComponent } from './components/billing/claims/claims-list/claims-list.component';
import { TimesheetPendedListComponent } from './components/payroll/timesheets/timesheet-pended-list/timesheet-pended-list.component';
import { TimesheetGoodToPayListComponent } from './components/payroll/timesheets/timesheet-goodtopay-list/timesheet-goodtopay-list.component';
import { PayrollNatPayListComponent } from './components/natPay/payroll-nat-pay-list/payroll-nat-pay-list.component';
import { TimesheetPayrollAdjustmentComponent } from './components/payroll/timesheets/timesheet-payroll-adjustment/timesheet-payroll-adjustment.component';
import { TimesheetBillingAdjustmentComponent } from './components/payroll/timesheets/timesheet-billing-adjustment/timesheet-billing-adjustment.component';
import { TimesheetPayrollAdjustmentApprovalsComponent } from './components/payroll/timesheets/timesheet-payroll-adjustment-approvals/timesheet-payroll-adjustment-approvals.component';
import { TimesheetBillingAdjustmentApprovalsComponent } from './components/payroll/timesheets/timesheet-billing-adjustment-approvals/timesheet-billing-adjustment-approvals.component';
import { AuthUtilizationAnalysisComponent } from './components/payroll/authorizations/auth-utilization-analysis/auth-utilization-analysis.component';
import { TimesheetPayrollResurrectComponent } from './components/payroll/timesheets/timesheet-payroll-resurrect/timesheet-payroll-resurrect.component';
import { MassAdjustmentsComponent } from './components/payroll/timesheets/mass-adjustments/mass-adjustments.component';
import { AddMassAdjustmentComponent } from './components/payroll/timesheets/mass-adjustments/add-mass-adjustment/add-mass-adjustment.component';
import { PaymentDetailsComponent } from './components/enrollment/payment-details/payment-details.component';
import { ConsumerRatesComponent } from './components/lead-details/consumer-rates/consumer-rates.component';
import { InvoiceConsumerListComponent } from './components/payroll/invoices/consumer/invoice-consumer-list/invoice-consumer-list.component';
import { InvoicesStaffListComponent } from './components/payroll/invoices/staff/invoices-staff-list/invoices-staff-list.component';
import { InvoiceGoodToPayListComponent } from './components/payroll/invoices/staff/invoice-goodtopay-list/invoice-goodtopay-list.component';
import { ProviderInvoiceComponent } from './components/payroll/invoices/provider/provider-invoice/provider-invoice.component';
import { PurchaseRequestParticipantViewComponent } from './components/payroll/purchase-request/purchase-request-participant-view/purchase-request-participant-view.component';
import { PurchaseRequestStaffViewComponent } from './components/payroll/purchase-request/purchase-request-staff-view/purchase-request-staff-view.component';
import { ProviderServiceCredentials } from './components/leads/provider-service-credentials/provider-service-credentials';
import { ParticipantSickTimeComponent } from './components/lead-details/participant-sick-time/participant-sick-time.component';
import { ProviderSickTimeComponent } from './components/lead-details/provider-sick-time/provider-sick-time.component';
import { InvoiceDetailComponent } from './components/payroll/invoices/invoice-details.component';
import { SickTimeDetailComponent } from './components/lead-details/sick-time-detail/sick-time-details.component';
import { BillingClaimAdjustmentComponent } from './components/payroll/claim-adjustment/billing-claim-adjustment/billing-claim-adjustment.component';
import { UnauthorizedComponent } from './components/core/unauthorized/unauthorized.component';
import { PurchaseAdjustmentComponent } from './components/payroll/purchase-request/purchase-adjustment/purchase-adjustment.component';
import { InvoiceAdjustmentComponent } from './components/payroll/invoices/invoice-adjustment/invoice-adjustment.component';
import { InvoicePayrollProcessingComponent } from './components/payroll/invoices/invoice-payroll-processing/invoice-payroll-processing.component';
import { TimesheetPayrollProcessingComponent } from './components/payroll/timesheets/timesheet-payroll-processing/timesheet-payroll-processing.component';
import { AddTimesheetPayrollBatchComponent } from './components/payroll/timesheets/timesheet-payroll-processing/add-timesheet-payroll-batch/add-timesheet-payroll-batch.component';
import { TimesheetPayrollRunResultsComponent } from './components/payroll/timesheets/timesheet-payroll-processing/timesheet-payroll-run-results/timesheet-payroll-run-results.component';
import { TimesheetPayrollRunErrorsComponent } from './components/payroll/timesheets/timesheet-payroll-processing/timesheet-payroll-run-errors/timesheet-payroll-run-errors.component';
import { PurchaseRequestPayrollAdjustmentApprovalsComponent } from './components/payroll/purchase-request/purchase-request-payroll-adjustment-approvals/purchase-request-payroll-adjustment-approvals.component';
import { InvoiceRequestPayrollAdjustmentApprovalsComponent } from './components/payroll/invoices/invoice-request-payroll-adjustment-approvals/invoice-request-payroll-adjustment-approvals.component';
import { RevertAdjustmentComponent } from './components/payroll/corrections/revert-adjustment/revert-adjustment.component';
import { ChequeVoidComponent } from './components/payroll/corrections/cheque-void/cheque-void.component';
import { NavResetComponent } from './components/payroll/corrections/nav-reset/nav-reset.component';
import { ReprocessComponent } from './components/payroll/corrections/reprocess/reprocess.component';
import { InvoicePendedListComponent } from './components/payroll/invoices/staff/invoice-pended-list/invoice-pended-list.component';
import { PayrollTabsLayoutComponent } from './components/payroll/payroll-tabs-layout/payroll-tabs-layout.component';

export const routes: Routes = [
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    children: [
      {
        path: 'participantLeadsList',
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ParticipantLeadsListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
          {
            path: 'leadDetails',
            component: MemberViewComponent,
            canActivate: [AuthGuard],
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'ppl-authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: 'Employers',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'communicationDetails',
                component: CommunicationDetailsComponent,
                data: {
                  breadcrumb: 'Communication Details',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Participant Leads',
        },
      },
      {
        path: 'providerLeadsList',
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ProviderLeadsListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },

          {
            path: 'leadDetails',
            component: MemberViewComponent,
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'prospectiveParticipants',
                component: ProspectiveParticipantsComponent,
                data: {
                  breadcrumb: 'Prospective Participants',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Provider Leads List',
        },
      },
      {
        path: 'participantEnrollmentList',
        children: [
          {
            path: '',
            component: ParticipantEnrollmentListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
          {
            path: 'details',
            component: MemberViewComponent,
            children: [
              {
                path: 'summary',
                component: LeadDetailSummaryComponent,
                data: {
                  breadcrumb: 'Summary',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'enrollmentInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Basic Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'toDoList',
                component: ToDoListComponent,
                data: {
                  breadcrumb: 'To Do List',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorizations',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorizations',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'consumerRates',
                component: ConsumerRatesComponent,
                data: {
                  breadcrumb: 'Participant Rates',
                  type: 'D',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'forms',
                component: FormChecklistComponent,
                data: {
                  breadcrumb: 'Forms',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: '',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetConsumerListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'purchaseRequests',
                component: PurchaseRequestParticipantViewComponent,
                data: {
                  breadcrumb: 'Purchase Request',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'invoices',
                component: InvoiceConsumerListComponent,
                data: {
                  breadcrumb: 'Invoices',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'checklist',
                component: ChecklistComponent,
                data: {
                  breadcrumb: 'Checklist',
                  isParticipant: true,
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'associations',
                component: AssociationsComponent,
                data: {
                  breadcrumb: 'Associations',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'signature',
                component: LeadDetailSignatureComponent,
                data: {
                  breadcrumb: 'Signature',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'sickTime',
                component: ParticipantSickTimeComponent,
                data: {
                  breadcrumb: 'Sick Time',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'additionalAttributes',
                component: AdditionalAttributesComponent,
                data: {
                  breadcrumb: 'Additional Attributes',
                },
                canActivate: [AuthGuard],
              },
            ]
          }]
      },
      {
        path: 'globalConsumerSearch',
        children: [
          {
            path: '',
            component: GlobalSearchComponent,
            pathMatch: 'full',
            canDeactivate: [],
            canActivate: [AuthGuard],
          },
          {
            path: 'details',
            component: MemberViewComponent,
            children: [
              {
                path: 'summary',
                component: LeadDetailSummaryComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'enrollmentInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'ppl-authorization',
                },
                canActivate: [AuthGuard],
              },

              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'toDoList',
                component: ToDoListComponent,
                data: {
                  breadcrumb: 'To Do List',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorizations',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorizations',
                },
                canActivate: [AuthGuard],
              },

              {
                path: 'forms',
                component: FormChecklistComponent,
                data: {
                  breadcrumb: 'Forms',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: '',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetConsumerListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'purchaseRequests',
                component: PurchaseRequestParticipantViewComponent,
                data: {
                  breadcrumb: 'Purchase Request',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'invoices',
                component: InvoiceConsumerListComponent,
                data: {
                  breadcrumb: 'Invoices',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'checklist',
                component: ChecklistComponent,
                data: {
                  breadcrumb: 'Checklist',
                  isParticipant: true,
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'associations',
                component: AssociationsComponent,
                data: {
                  breadcrumb: 'Associations',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'signature',
                component: LeadDetailSignatureComponent,
                data: {
                  breadcrumb: 'Signature',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'additionalAttributes',
                component: AdditionalAttributesComponent,
                data: {
                  breadcrumb: 'Additional Attributes',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'consumerRates',
                component: ConsumerRatesComponent,
                data: {
                  breadcrumb: 'Participant Rates',
                  type: 'D',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'sickTime',
                component: SickTimeDetailComponent,
                data: {
                  breadcrumb: 'Sick Time',
                },
                canActivate: [AuthGuard],
              },
            ]
          }]
      },
      {
        path: 'providerEnrollmentList',
        children: [
          {
            path: '',
            component: ProviderEnrollmentListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
          {
            path: 'details',
            component: MemberViewComponent,
            children: [
              {
                path: 'summary',
                component: LeadDetailSummaryComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'enrollmentInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'ppl-authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'toDoList',
                component: ToDoListComponent,
                data: {
                  breadcrumb: 'To Do List',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'consumerRates',
                component: ConsumerRatesComponent,
                data: {
                  breadcrumb: 'Participant Rates',
                  type: 'D',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'forms',
                component: FormChecklistComponent,
                data: {
                  breadcrumb: 'Forms',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: '',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'benefits',
                component: BenefitsComponent,
                data: {
                  breadcrumb: 'Benefits',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'checklist',
                component: ChecklistComponent,
                data: {
                  breadcrumb: 'Checklist',
                  isParticipant: false
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'associations',
                component: AssociationsComponent,
                data: {
                  breadcrumb: 'Associations',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'service-credentials',
                component: ProviderServiceCredentials,
                data: {
                  breadcrumb: 'Service Credentials',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'signature',
                component: LeadDetailSignatureComponent,
                data: {
                  breadcrumb: 'Signature',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'additionalAttributes',
                component: AdditionalAttributesComponent,
                data: {
                  breadcrumb: 'Additional Attributes',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'invoices',
                component: ProviderInvoiceComponent,
                data: {
                  breadcrumb: 'Invoice',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'sickTime',
                component: ProviderSickTimeComponent,
                data: {
                  breadcrumb: 'Sick Time',
                },
                canActivate: [AuthGuard],
              }
            ]
          }]
      },
      {
        path: 'newEnrollment',
        component: NewReferralComponent,
        children: [
          {
            path: 'participant_info',
            component: ParticipantInformationComponent,
          },
          { path: 'contact_details', component: ContactDetailsComponent },
          { path: 'comm_preferences', component: CommPreferenceComponent },
          { path: 'service_details', component: ServiceDetailsComponent },
          { path: 'upload_docs', component: UploadDocsComponent },
          { path: 'signatures', component: UploadSignaturesComponent },
          { path: 'associations', component: NewContactComponent },
          { path: 'forms', component: FormChecklistComponent },
          { path: 'payment_details', component: PaymentDetailsComponent },
          { path: 'summary', component: SummaryComponent },
        ],
        canActivate: [AuthGuard],
      },
      { path: 'newEnrollmentForm/:flow', component: NewEnrollmentComponent },
      {
        path: 'payrollProcessing',
        component: PayrollProcessingComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: PayrollProcessingComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          }
        ]
      },
      {
        path: 'claimBatchesList',
        component: ViewBatchesComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: BatchesListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
        ]
      },
      {
        path: 'viewClaimsList',
        component: ViewClaimsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ClaimsListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
        ]
      },
      {
        path: 'claimFilesList',
        component: ViewFilesComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: FilesListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
        ]
      },
      {
        path: 'referralList',
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ReferralListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
          {
            path: 'referralDetails',
            component: MemberViewComponent,
            canActivate: [AuthGuard],
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: 'Employers',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'communicationDetails',
                component: CommunicationDetailsComponent,
                data: {
                  breadcrumb: 'Communication Details',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Referrals',
        },
      },
      {
        path: 'enrollmentDetails',
        component: MemberViewComponent,
        children: [
          {
            path: 'summary',
            component: LeadDetailSummaryComponent,
            data: {
              breadcrumb: 'Authorization',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'enrollmentInformation',
            component: LeadInformationComponent,
            data: {
              breadcrumb: 'ppl-authorization',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'benefits',
            component: BenefitsComponent,
            data: {
              breadcrumb: 'Benefits',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'toDoList',
            component: ToDoListComponent,
            data: {
              breadcrumb: 'To Do List',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'service-credentials',
            component: ProviderServiceCredentials,
            data: {
              breadcrumb: 'Service Credentials',
            },
            canActivate: [AuthGuard],
          },

          {
            path: 'authorization',
            component: AuthorizationComponent,
            data: {
              breadcrumb: 'Authorization',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'employers',
            component: EmployerComponent,
            data: {
              breadcrumb: '',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'documents',
            component: DocumentsComponent,
            data: {
              breadcrumb: 'Documents',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'forms',
            component: FormChecklistComponent,
            data: {
              breadcrumb: 'Forms',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'checklist',
            component: ChecklistComponent,
            data: {
              breadcrumb: 'Checklist'
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'associations',
            component: AssociationsComponent,
            data: {
              breadcrumb: 'Associations',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'consumerRates',
            component: ConsumerRatesComponent,
            data: {
              breadcrumb: 'Consumer Rates',
              type: 'D',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'timesheets',
            component: TimesheetDetailComponent,
            data: {
              breadcrumb: 'Timesheets',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'invoices',
            component: InvoiceDetailComponent,
            data: {
              breadcrumb: 'Invoices',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'purchaseRequests',
            component: PurchaseRequestParticipantViewComponent,
            data: {
              breadcrumb: 'Purchase Request',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'signature',
            component: LeadDetailSignatureComponent,
            data: {
              breadcrumb: 'Signature',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'additionalAttributes',
            component: AdditionalAttributesComponent,
            data: {
              breadcrumb: 'Additional Attributes',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'authorizations',
            component: AuthorizationComponent,
            data: {
              breadcrumb: 'Authorizations',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'sickTime',
            component: SickTimeDetailComponent,
            data: {
              breadcrumb: 'Sick Time',
            },
            canActivate: [AuthGuard],
          }
        ],
      },
      { /* path: 'enrollmentList', component: EnrollmentsComponent, */
        path: 'enrollmentList',
        component: EnrollmentListComponentOld,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: EnrollmentListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
          {
            path: 'referralDetails',
            component: MemberViewComponent,
            canActivate: [AuthGuard],
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'authorization',
                component: AuthorizationComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'employers',
                component: EmployerComponent,
                data: {
                  breadcrumb: 'Employers',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'timesheets',
                component: TimesheetProviderListComponent,
                data: {
                  breadcrumb: 'Timesheets',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'documents',
                component: DocumentsComponent,
                data: {
                  breadcrumb: 'Documents',
                },
                canActivate: [AuthGuard],
              },
              {
                path: 'communicationDetails',
                component: CommunicationDetailsComponent,
                data: {
                  breadcrumb: 'Communication Details',
                },
                canActivate: [AuthGuard],
              },
            ],
          },
        ],
        data: {
          breadcrumb: 'Referrals',
        },
      },
      {
        path: 'processCode/:action',
        component: AddProcessCodeComponent,
        canActivate: [AuthGuard],
      },
      // Pages shown as tabs (MENU_TAB_GROUPS). Empty-path parents keep each page's URL unchanged.
      {
        path: '',
        component: PayrollTabsLayoutComponent,
        data: { menuTabGroup: 'timesheets' },
        children: [
          {
            path: 'timesheet',
            component: TimesheetStaffListComponent,
            data: {
              breadcrumb: 'timesheet',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'pendedTimesheets',
            component: TimesheetPendedListComponent,
            data: {
              breadcrumb: 'Pended Timesheets',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'goodToPayTimesheets',
            component: TimesheetGoodToPayListComponent,
            data: {
              breadcrumb: 'Good To Pay Timesheets',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'payrollAdjustment',
            component: TimesheetPayrollAdjustmentComponent,
            data: {
              breadcrumb: 'Payroll Adjustment',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'payrollApprovals',
            component: TimesheetPayrollAdjustmentApprovalsComponent,
            data: {
              breadcrumb: 'Payroll Approvals',
            },
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: '',
        component: PayrollTabsLayoutComponent,
        data: { menuTabGroup: 'revertAdjustment' },
        children: [
          {
            path: 'revertAdjustment',
            component: RevertAdjustmentComponent,
            data: {
              breadcrumb: 'Revert Adjustments',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'chequeVoid',
            component: ChequeVoidComponent,
            data: {
              breadcrumb: 'Void Checks',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'navReset',
            component: NavResetComponent,
            data: {
              breadcrumb: 'NAV Reset',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'reprocess',
            component: ReprocessComponent,
            data: {
              breadcrumb: 'Reprocess',
            },
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: '',
        component: PayrollTabsLayoutComponent,
        data: { menuTabGroup: 'invoices' },
        children: [
          {
            path: 'invoices',
            component: InvoicesStaffListComponent,
            data: {
              breadcrumb: 'Invoices',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'pendedInvoices',
            component: InvoicePendedListComponent,
            data: {
              breadcrumb: 'Pended Invoices',
            },
            canActivate: [AuthGuard],
          },
          {
            path: 'goodToPayInvoices',
            component: InvoiceGoodToPayListComponent,
            data: {
              breadcrumb: 'Good To Pay Invoices',
            },
            canActivate: [AuthGuard],
          },
          { path: 'invoiceAdjustment', component: InvoiceAdjustmentComponent },
          {
            path: 'invoiceApprovals',
            component: InvoiceRequestPayrollAdjustmentApprovalsComponent,
          },
        ],
      },
      {
        path: '',
        component: PayrollTabsLayoutComponent,
        data: { menuTabGroup: 'purchaseRequests' },
        children: [
          {
            path: 'purchaseRequests',
            component: PurchaseRequestStaffViewComponent,
            data: {
              breadcrumb: 'Purchase Request',
            },
            canActivate: [AuthGuard],
          },
          { path: 'purchaseAdjustment', component: PurchaseAdjustmentComponent },
          {
            path: 'purchaseRequestApprovals',
            component: PurchaseRequestPayrollAdjustmentApprovalsComponent,
          },
        ],
      },
      {
        path: 'timesheetPayrollProcessing',
        component: TimesheetPayrollProcessingComponent,
        data: {
          breadcrumb: 'Payroll Processing',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'invoicePayrollProcessing',
        component: InvoicePayrollProcessingComponent,
        data: {
          breadcrumb: 'Invoice Payroll Processing',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'addTimesheetPayrollBatch',
        component: AddTimesheetPayrollBatchComponent,
        data: {
          breadcrumb: 'New Payroll Processing',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'timesheetPayrollRunResults',
        component: TimesheetPayrollRunResultsComponent,
        data: {
          breadcrumb: 'Payroll Run Results',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'timesheetPayrollRunErrors',
        component: TimesheetPayrollRunErrorsComponent,
        data: {
          breadcrumb: 'Payroll Run Errors',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'payrollResurrect',
        component: TimesheetPayrollResurrectComponent,
        data: {
          breadcrumb: 'Payroll Resurrect',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'bulkAdjustments',
        component: MassAdjustmentsComponent,
        data: {
          breadcrumb: 'Bulk Adjustments',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'addBulkAdjustment',
        component: AddMassAdjustmentComponent,
        data: {
          breadcrumb: 'Add Bulk Adjustment',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'bulkBatchResultList',
        component: MassBatchResultListComponent,
        data: { breadcrumb: 'Bulk Batch Result List' },
        canActivate: [AuthGuard],
      },
      {
        path: 'bulkBatchErrorList',
        component: MassBatchErrorListComponent,
        data: { breadcrumb: 'Bulk Batch Error List' },
        canActivate: [AuthGuard],
      },
      {
        path: 'processCodeList',
        component: ProcessCodeListComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ProcessCodeListComponent,
            pathMatch: 'full',
            canActivate: [AuthGuard],
          },
        ]
      },
      {
        path: 'billingClaimAdjustment',
        component: BillingClaimAdjustmentComponent,
        data: {
          breadcrumb: 'Claims Adjustment',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'serviceCode/:action',
        component: AddServiceCodeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'serviceCodeList',
        component: ServiceCodeListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'caseManagerDetails',
        component: CaseManagerDetailsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'caseManagerList',
        component: CaseManagerListComponent,
        canActivate: [AuthGuard]
      },
      /* {
        path: 'authorizations',
        component: AuthorizationsListComponent,
        canActivate: [AuthGuard],
        data: {
          breadcrumb: 'Referrals',
        },
            children: [
              {
                path: 'participantInformation',
                component: LeadInformationComponent,
                data: {
                  breadcrumb: 'Participant Information',
                },
                canActivate: [AuthGuard],
              },
            ]
      }, */


      {
        path: 'authorizations',
        children: [
          {
            path: '',
            component: AuthorizationsListComponent,
            pathMatch: 'full',
            canDeactivate: [],
            canActivate: [AuthGuard],
          },
          {
            path: 'details',
            component: AuthorizationMemberViewComponent,
            children: [
              {
                path: 'authorization',
                component: AuthorizationDetailsComponent,
                data: {
                  breadcrumb: 'Authorization',
                },
                canActivate: [AuthGuard],
              },

            ]
          }
        ]
      },
      {
        path: 'spendingPlans',
        component: SpendingPlansListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'authUtilizationAnalysis',
        component: AuthUtilizationAnalysisComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'addAuthorizations',
        component: AddAuthorizationComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'addParticipantProviderRates/:action',
        component: AddParticipantProviderRatesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'participantProviderRatesList',
        component: ParticipantProviderRatesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'addPayablePersonalAssistantRates/:action',
        component: AddPayableProviderRatesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'payablePersonalAssistantRates',
        component: PayableProviderRatesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'addBillablePersonalAssistantRates/:action',
        component: AddBillableProviderRatesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'billablePersonalAssistantRates',
        component: BillableProviderRatesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'fileTriage',
        component: FileTriageListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'payrollNATPay',
        component: PayrollNatPayListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'fileUploadNotification',
        component: FileUploadNotificationListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'claimBatchesList',
        component: BatchesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'claimFilesList',
        component: FilesListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'billingAdjustment',
        component: TimesheetBillingAdjustmentComponent,
        data: {
          breadcrumb: 'Billing Adjustment',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'billingApprovals',
        component: TimesheetBillingAdjustmentApprovalsComponent,
        data: {
          breadcrumb: 'Billing Approval',
        },
        canActivate: [AuthGuard],
      }
    ],
    canActivate: [MsalGuard],
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'programs',
    component: DashboardComponent,
    canActivate: [MsalGuard],
    data: {
      breadcrumb: 'Provider Leads List',
    },
  },
  {
    path: 'referralLogic',
    component: ReferralLogicComponent,
    data: {
      breadcrumb: 'Provider Leads List',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'confirmation',
    component: MessageComponent,
  },
  {
    path: 'newReferral',
    component: NewReferralComponent,
    children: [
      { path: '', component: ParticipantInformationComponent },
      { path: 'participant_info', component: ParticipantInformationComponent },
      { path: 'contact_details', component: ContactDetailsComponent },
      { path: 'comm_preferences', component: CommPreferenceComponent },
      { path: 'service_details', component: ServiceDetailsComponent },
      { path: 'upload_docs', component: UploadDocsComponent },
      { path: 'signatures', component: UploadSignaturesComponent },
      { path: 'associations', component: NewContactComponent },
      { path: 'consumer_rates', component: ConsumerRatesComponent, data: { type: 'R' } },
      { path: 'service_credentials', component: ProviderServiceCredentials },
      { path: 'forms', component: FormChecklistComponent, data: { isNewReferral: true } },
      { path: 'payment_details', component: PaymentDetailsComponent },
      { path: 'summary', component: SummaryComponent, data: { isNewReferral: true } },
    ],
    canActivate: [AuthGuard],
  }
];
